import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from '@kyruus/intl';
import { Box } from '@biome-design-system/ui/Box';
import { Typography } from '@biome-design-system/ui/Typography';
import { List } from '@biome-design-system/ui/List';

import {
  type Log,
  type SearchSuggestion,
  type GetUpdatedSearch,
  type SearchSummary
} from 'Src/types';
import { messages } from './messages';
import { isSearchRefined } from '../../utils/search-common';
import { SearchSuggestions } from './SearchSuggestions';
import { RefinedSearchMessage } from './RefinedSearchMessage';

interface SuggestionsProps {
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
  searchSummary: SearchSummary;
  suggestions: SearchSuggestion[];
}

export const Suggestions = ({
  getUpdatedSearch,
  log,
  searchSummary,
  suggestions
}: SuggestionsProps) => {
  const shouldShowRefinedSearch = isSearchRefined(searchSummary);
  const noSuggestions = _isEmpty(suggestions);

  if (noSuggestions && !shouldShowRefinedSearch) {
    return null;
  }

  return (
    <Box sx={{ backgroundColor: 'background.info', p: 2 }}>
      <Typography id="suggestions-header" component="h3" variant="h5">
        <FormattedMessage {...messages.suggestionsHeader} />
      </Typography>
      <List
        data-testid="noResults.suggestions"
        aria-labelledby="suggestions-header"
        sx={{
          listStyleType: 'disc',
          pl: 2,
          li: { display: 'list-item', pl: 1 }
        }}
      >
        {shouldShowRefinedSearch && (
          <RefinedSearchMessage getUpdatedSearch={getUpdatedSearch} log={log} />
        )}
        {noSuggestions === false && (
          <SearchSuggestions
            suggestions={suggestions}
            getUpdatedSearch={getUpdatedSearch}
            log={log}
          />
        )}
      </List>
    </Box>
  );
};
